<template>
  <Button
    v-bind="$attrs"
    class="elsa-purple-button"
  >
    <slot/>
  </Button>
</template>

<script>
import Button from './Button';

export default {
  name: "SecundaryButton",
  components: {
    Button
  },
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/colors";

.elsa-purple-button.el-button {
  height: 40px;
  padding: 0;
  &[disabled="disabled"], &[disabled="disabled"]:hover, &[disabled="disabled"] {
    background: $white;
    border: 2px solid rgba(109, 122, 140, 0.2);
    color:rgba(109, 122, 140, 0.18);;
  }

  &, &:active, &:focus {
    background: $white;
    border: 1px solid $purple;
    color: $purple;
  }

  &:hover {
    background-color: $purple;
    border: 2px solid $purple;
    color: $white;
  }
}

.elsa-social-button.el-button {
  height: 40px;
  padding: 5px;
  border-radius: 8px;
  &, &:active, &:focus {
    background: linear-gradient(0.96deg, #29F4FF -45.5%, #5257FF 91.65%);
    box-shadow: 0px 8px 18px rgba(69, 137, 255, 0.26);
    box-sizing: border-box;
    color: white;
    border: none;
  }

  &:hover {
    background-color: white;
    color: $purple;
    box-sizing: border-box;
    border: 3px solid $purple;
    &::v-deep span img {
      filter: invert(52%) sepia(66%) saturate(2683%) hue-rotate(202deg) brightness(102%) contrast(102%);
    }
  }

  &::v-deep span img {
    padding-left: 0;
  }
}

</style>>
